import { InfiniteData, useInfiniteQuery } from "@tanstack/react-query"

import { IUseInfiniteGetSearchResult } from "./type"

import { FeatureData } from "providers/venue/types"
import { InfiniteQueryFnData } from "providers/venue/modules/client-query/types"
import {
  createGetListQueryKey,
  createInfiniteGetListQueryFn,
} from "providers/venue/modules/client-query/factory"

type TQueryFnData = InfiniteQueryFnData<FeatureData>
type TInfiniteData = InfiniteData<TQueryFnData>

const DEFAULT_QUERY_KEY = ["features"]

export const useInfiniteGetSearchResult = ({
  queryKey = DEFAULT_QUERY_KEY,
  pagination,
  filter,
  searchFn,
  ...props
}: IUseInfiniteGetSearchResult<TQueryFnData, TInfiniteData>) => {
  const resourceKey = [...queryKey, "getInfiniteList"]
  return useInfiniteQuery<TQueryFnData, unknown, TInfiniteData>({
    queryKey: createGetListQueryKey(resourceKey, {
      filter,
    }),
    queryFn: async (context) => {
      const { q, venueId } = filter
      const sourceData = searchFn(q, venueId)
      const infiniteGetListQueryFn = createInfiniteGetListQueryFn<
        FeatureData,
        TQueryFnData
      >(sourceData, {
        pagination,
      })
      //@ts-ignore
      return await infiniteGetListQueryFn(context)
    },
    refetchOnWindowFocus: false,
    initialPageParam: 1,
    ...props,
    getPreviousPageParam: (firstPage, pages) => firstPage.prevPage,
    getNextPageParam: (lastPage, pages) => lastPage.nextPage,
  })
}
